import React from 'react'

import {
    PopupTitle,
    PopupContainer,
    PopupDescription,
    PopupButtonsContainer,
    PopupButton,
    TitleContainer
} from "../CandidateView.styles";

interface NoShowConfirmationProps {
    onConfirm: () => Promise<void>
    onCancel: () => void
}

const NoShowConfirmation = ({
    onConfirm,
    onCancel,
}: NoShowConfirmationProps) => {
    return (
        <PopupContainer>
            <TitleContainer><PopupTitle>Confirm Interview No-Show?</PopupTitle></TitleContainer>
            <PopupDescription>
                {`Did you schedule an interview with this candidate and they missed it without contacting you first?

We track interview no-shows, and this can affect the Candidate's ability to book future interviews.

So please only mark a No-Show if the candidate just didn't show up for their interview, and didn't contact you to cancel it.`}
            </PopupDescription>
            <PopupButtonsContainer>
                <PopupButton
                    variant="outlined"
                    onClick={onCancel}
                    color="primary"
                    size="large"
                    id="cancel-button"
                    className="bigButtonInNewStyle"
                >
                    Go Back
                </PopupButton>
                <PopupButton
                    variant="contained"
                    onClick={onConfirm}
                    color="primary"
                    size="large"
                    id="confirm-button"
                    className="bigButtonInNewStyle"
                >
                    Confirm No-Show
                </PopupButton>
            </PopupButtonsContainer>
        </PopupContainer>
    )
}

export default NoShowConfirmation;
